import { render, staticRenderFns } from "./PermissionDataTable.vue?vue&type=template&id=4d87dc32&"
import script from "./PermissionDataTable.vue?vue&type=script&lang=js&"
export * from "./PermissionDataTable.vue?vue&type=script&lang=js&"
import style0 from "./PermissionDataTable.vue?vue&type=style&index=0&id=4d87dc32&prod&language=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports